const categories = [
    {
      name: 'Microphones',
      image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1737758880/Ad2_1_qynkaj.png',
    },
    {
      name: 'Amplifiers',
      image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1737828023/Amplifier_1_ktzklr.jpg',
    },
    {
        name: 'Mixers',
        image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1738007361/mixer_4_lrokqb.jpg',
    },
    {
        name: 'Microphone Racks',
        image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1737759708/racks_1_plne11.jpg',
    },
    {
      name: 'Power Distributor',
      image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1738343723/3_Phase_6_channel_Power_distrubutor_3_ob19uf.jpg',
    },
    {
        name: 'Speakers',
        image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1738342851/Passive_single_18_inch_Sub_urlxvi.jpg',
    },
    {
        name: 'Flight Cases',
        image: 'https://res.cloudinary.com/dubzg5mqz/image/upload/v1763471065/fl5_t488e6.jpg',
    },
  ];
  
  export default categories;
  
